import { SxProps, Theme } from '@mui/material';

const normalizeCategoryKey = (category: string): string =>
    category?.trim().toLocaleUpperCase('tr-TR') ?? '';

export const getPromptTypeChipSx = (): SxProps<Theme> => ({
    borderColor: '#1976d2',
    color: '#1565c0',
    backgroundColor: 'rgba(25, 118, 210, 0.08)',
    fontWeight: 600,
    flexShrink: 0,
});

export const getPromptCategoryChipSx = (category: string): SxProps<Theme> => {
    const key = normalizeCategoryKey(category);

    if (key === 'ÜST' || key === 'UST') {
        return {
            borderColor: '#ed6c02',
            color: '#e65100',
            backgroundColor: 'rgba(237, 108, 2, 0.1)',
            fontWeight: 600,
            flexShrink: 0,
        };
    }

    if (key === 'ALT') {
        return {
            borderColor: '#7b1fa2',
            color: '#6a1b9a',
            backgroundColor: 'rgba(123, 31, 162, 0.1)',
            fontWeight: 600,
            flexShrink: 0,
        };
    }

    return {
        borderColor: 'rgba(0, 0, 0, 0.23)',
        color: 'text.secondary',
        flexShrink: 0,
    };
};
